import { createFileRoute } from "@tanstack/react-router";

import { LegalDocumentPage } from "~/components/legal/LegalDocumentPage";

export const Route = createFileRoute("/(public)/actievoorwaarden")({
  component: () => <LegalDocumentPage type="actievoorwaarden" title="Actievoorwaarden" />,
});
